<template>
    <v-alert
        v-if="feature_in_beta"
        border="left"
        colored-border
        color="primary"
        elevation="2"
        type="info"
        dismissible
    >
        <p
            v-if="(description ?? '').trim().length > 0"
            v-html="description"
        >
        </p>
        <p
            v-if="(description ?? '').trim().length == 0 && !dense"
        >
            Heads up! This feature is still under development (in "beta"), but available for you to try.
            It might have a few bugs, but we are eager to get your feedback.
        </p>
        
        <div
            v-if="!dense"
        >
            If you encounter any issues, please <a @click="contactSupport">click here to contact RedChirp support</a>.
            <br/><br/>
            
            This feature was first available on {{ start_date }}, and is expected to be released for general use around {{ planned_end_date }}.
        </div>

        <template v-if="hasSlotContent">
            <br v-if="!dense"/><br v-if="!dense"/>
            <slot></slot>
        </template>
    </v-alert>
</template>

<script>
export default {
    props: {
        code: {
            type: String,
            default: function() { return null; }
        },

        description: {
            type: String,
            default: function() { return null; }
        },

        dense: {
            type: Boolean,
            default: function() { return false; }
        }
    },

    data() {
        return {
            feature: null
        }
    },

    mounted() {
        this.feature = this.$rc.enumObject('beta_features', this.code);
    },

    methods: {
        contactSupport() {
            this.$rc.contactSupport('Beta Feature (' + this.code + ')');
        }
    },

    computed: {
        feature_in_beta() {
            // Alerts are safe to leave in the code even after a feature is removed from beta
            // The alert will simply cease to show when the enum value is deleted
            return this.$rc.isValidEnumValue(this.code, 'beta_features');
        },

        start_date() {
            return this.feature?.start_date || "<Unknown>";
        },

        planned_end_date() {
            return this.feature?.planned_end_date || "<Unknown>";
        },

        hasSlotContent() {
            return !!this.$slots.default;
        }
    }
}</script>


<style lang="scss" scoped>
</style>

